import { useRequest } from 'ahooks';
import { getPopularLatestPolicy } from '@axios/api'
import util from '../../../utils/utils';

function useGetPopularPolicy(){
  const cacheKey = `popularPolicy:${util.getCurrentClientId()}`;
  const { loading, data, run } = useRequest(
    async () => {
      try {
        const resp = await getPopularLatestPolicy({num:5,select_by:'click_num'});
        return resp?.data?.result ?? []
      } catch (error) {
        return [];
      }
    },
    {       
     refreshDeps:[],   
      debounceWait: 50,     // ✅ 增加到500毫秒
      retryCount: 1,
      // ✅ 缓存配置：10分钟内复用
      cacheKey,
      staleTime: 10 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  );

    return {
      popularPolicyLoading:loading,
      popularPolicyData:data,
    }
}

export default useGetPopularPolicy